import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const STORAGE_KEY = "fb_lang";
const LanguageContext = createContext(null);

function initialLang() {
  const saved = typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
  return saved === "en" || saved === "es" ? saved : "es"; // Spanish default
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(initialLang);

  const setLang = useCallback((next) => {
    setLangState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
      document.documentElement.lang = next;
    } catch (e) {}
  }, []);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
